import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Input, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Pagination } from '@app/core/model/pagination.model';
//import { UserSimpleGamification, UserSimpleGoal } from '@app/leaderboard/model/user.model';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LeaderboardLazyService } from '@app/leaderboard/service/leaderboard/leaderboard-lazy.service';

@Component({
    selector: 'app-leaderboard',
    templateUrl: './leaderboard.component.html',
    styleUrls: ['./leaderboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LeaderboardComponent implements OnInit, OnDestroy {
    @Input() name!: string;

    @Input() size!: 'sm' | 'md' | 'lg';

    private subscriptions$ = new Subscription();

    private readonly leaderboardLazyService = inject(LeaderboardLazyService);
    private readonly activatedRoute: any = inject(ActivatedRoute);
    private readonly translateService = inject(TranslateService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    readonly form = this.leaderboardLazyService.form;

    ngOnInit() {
        this.subscriptions$.add(this.leaderboardLazyService.updates.subscribe(() => this.changeDetectorRef.detectChanges()));
        if (this.activatedRoute.firstChild.snapshot.params.range) {
            this.setRange(this.activatedRoute.firstChild.snapshot.params.range);
        }
    }

    ngOnDestroy() {
        this.leaderboardLazyService.reset();
        this.subscriptions$.unsubscribe();
    }

    setRange(routeRange: string) {
        const index = this.leaderboardLazyService.ranges.findIndex((range) => {
            return range === routeRange;
        });
        if (index !== -1) {
            this.leaderboardLazyService.form.patchValue({ range: this.leaderboardLazyService.ranges[index] });
        }
    }

    get leaderboard() {
        return this.leaderboardLazyService.leaderboard;
    }

    get loading() {
        return this.leaderboardLazyService.loading;
    }

    get hasUsers(): boolean {
        return this.totalUsers > 0;
    }

    get totalUsers(): number {
        return this.leaderboardLazyService.total;
    }

    get pagination() {
        return this.leaderboardLazyService.pagination;
    }

    set pagination(pagination: Pagination) {
        this.leaderboardLazyService.pagination = pagination;
    }

    get dropdownRanges() {
        return this.leaderboardLazyService.ranges.map((name) => {
            return {
                id: name,
                name: this.rangeLabel(name),
            };
        });
    }

    get dropdownTypes() {
        return this.leaderboardLazyService.types.map((name: any) => {
            return {
                id: name,
                name: this.typeLabel(name),
            };
        });
    }

    get dropdownTypesAvailable(): boolean {
        return this.leaderboardLazyService.types.length > 1;
    }

    onReachEnd() {
        if (this.leaderboard && this.leaderboard.length) {
            this.leaderboardLazyService.getLeaderBoard();
            this.changeDetectorRef.detectChanges();
        }
    }

    //typeGamification(user: UserSimpleGamification) {
    typeGamification(user: any) {
        return user.points !== undefined;
    }

    //typeGoal(user: UserSimpleGoal) {
    typeGoal(user: any) {
        return user.watched !== undefined;
    }

    rangeLabel(key: string) {
        switch (key) {
            case 'week':
                return this.translateService.instant('v3-preview-leaderboard-range-week');
            case 'month':
                return this.translateService.instant('v3-preview-leaderboard-range-month');
            case 'all-time':
                return this.translateService.instant('v3-preview-leaderboard-range-all-time');
            case 'alltime':
                return this.translateService.instant('v3-preview-leaderboard-range-alltime');
            case 'yeartodate':
                return this.translateService.instant('v3-preview-leaderboard-range-year-to-date');
        }
    }

    private typeLabel(key: string) {
        switch (key) {
            case 'goal':
                return this.translateService.instant('v3-preview-leaderboard-type-goal');
            case 'learning':
                return this.translateService.instant('v3-preview-leaderboard-type-gamification');
            case 'gamification':
                return this.translateService.instant('v3-preview-leaderboard-type-gamification');
        }
    }
}
